/* eslint-disable @typescript-eslint/no-explicit-any, camelcase */

/**
 * This file is autogenerated, please don't edit it manually.
 * Use this command to regenerate it if you modified Epic experiments:
 * yarn epic:types
 */

/**
 * Epic experiments namespaces with their possible keys.
 * Autogenerated from static/bundles/epic/data/defaults/
 */
import client from 'bundles/epic/client';
import Workspaces from 'bundles/epic/data/defaults/Workspaces.json';
import type { Tags } from 'bundles/epic/lib/EpicTypes';

type Namespace = {
  sleuthAssignments: any;
  unlimitedImagesEnabledCourseIds: any;
  labPlaygroundConfiguration: any;
  resourceLimitsOverrides: any;
  enabledCourseIdsForChallengeLabs: any;
  enabledCourseIdsForLabEducatorAnalytics: any;
  enabledCourseIdsForImageVersioning: any;
  enabledCourseIdsForInstructorLaunchLab: any;
  isNewLabSetupFlowEnabled: boolean;
  enabledCourseIdsForAwsCloudLabs: any;
  supportedLlmForCourse: any;
  tensorflowGpuCourseIds: any;
  coachLabItemPrompt: any;
};

const NAMESPACE = 'Workspaces';

// Adding safe optional chaining to avoid massive changes in unit tests.
client.addDefaults?.([Workspaces as $TSFixMe]);

const WorkspacesEpicClient = {
  get<K extends keyof Namespace>(key: K, tags?: Tags): Namespace[K] {
    return client.get(NAMESPACE, key, tags);
  },

  preview<K extends keyof Namespace>(key: K, tags?: Tags, defaults?: Namespace): Namespace[K] {
    return client.preview(NAMESPACE, key, tags);
  },
};

export default WorkspacesEpicClient;
